class CustomBackInStockForm extends HTMLElement {
  constructor() {
    super();

    const form = this.querySelector("form");
    this.button = this.querySelector("button");
    // this.form.addEventListener("submit", this.handleSubmit.bind(this));
    let checkBISActive = setInterval(function() {
      
      if (window.BIS != null) {
        this.button.classList.remove('loading');
        this.button.classList.remove('disabled');
        form.addEventListener("submit", this.handleSubmit.bind(this));
        clearInterval(checkBISActive); // stop the interval
      }
    }.bind(this), 1000);

  }

  async handleSubmit(event) {
    event.preventDefault();
    this.button.classList.add("loading");
    this.querySelectorAll(".success, .error").forEach((message) => {
      message.classList.add("hidden");
    });

    const formData = new FormData(event.currentTarget);

    const email = formData.get("email");
    const variantId = formData.get("variant");
    const productId = formData.get("product_id");
    const acceptsMarketing = JSON.parse(formData.get("acceptsMarketing"));

    try {
      const response = await window.BIS.create(email, variantId, productId, {
        accepts_marketing: acceptsMarketing,
      });
      if (
        response.status !== "OK" &&
        response.errors.base?.every(
          (error) => !error.includes("already registered")
        )
      ) {
        throw response;
      }

      this.querySelector(".success").classList.remove("hidden");
    } catch (error) {
      console.error(error);
      this.querySelector(".error").classList.remove("hidden");
    }
    
    this.button.classList.remove("loading");

  }
}

customElements.define("back-in-stock-form", CustomBackInStockForm);
